import {createAsyncThunk} from '@reduxjs/toolkit';
import getExperiments from 'api/experiments/experiments';

/**
 * Gets the experiments associated with the logged-in user
 *
 */
export const getExperimentsData = createAsyncThunk(
    'user/getExperimentsData',
    async (_, {rejectWithValue}) => {
        try {
            const response = await getExperiments();

            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
